import { defineStore } from 'pinia'

export interface ActionButtonState {
  isStart: boolean,
  touchStart: boolean,
  showMovementControl: boolean
}

const initialState = (): ActionButtonState => ({
  isStart: true,
  touchStart: false,
  showMovementControl: false
})

export const actionButtonState = defineStore('actionButtonState', {
  state: initialState,
})
